import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { runConfetti } from '@utils/confetti';

interface Props {
  isOpen: boolean;
  toggle: (hasCompleted?: boolean) => Promise<void> | void;
}

export const MaterialityCompletionModal = ({ isOpen, toggle }: Props) => {
  const handleComplete = () => {
    runConfetti();
    return toggle(true);
  };

  return (
    <Modal isOpen={isOpen} toggle={() => toggle()} backdrop='static'>
      <ModalHeader toggle={() => toggle()}>🎉 You did it! 🎉</ModalHeader>
      <ModalBody>
        <p>Congratulations on completing the materiality assessment!</p>
        <p>
          The next step is to submit your assessments so we can calculate your results and generate a materiality report
          for your organisations.
        </p>
        <p className='mb-0 text-danger'>
          <strong>Please note:</strong> You will not be able to update your questions once you have clicked 'submit'.
          Please ensure you are happy with your answers before submitting.
        </p>
      </ModalBody>
      <ModalFooter>
        <Button color='link-secondary' className='mr-3' onClick={() => toggle()}>
          Review answers (no submission)
        </Button>
        <Button color='primary' onClick={handleComplete}>
          Submit assessment
        </Button>
      </ModalFooter>
    </Modal>
  );
};
